/* Backend may return the literal "Venn" as a data source. Swap it for the active brand title
 * so rebranded deployments (e.g. Risk Pro) don't leak "Venn" into the UI. */
import { getAppTitle } from './getAppTitle';

export const rebrandDataSource = (dataSource: string | undefined): string | undefined =>
  dataSource?.trim().toLowerCase() === 'venn' ? getAppTitle() : dataSource;
